export class Router {
    constructor(config) {
        this.pageBuilder = config.pageBuilder;
        this.notFound = config.notFound;
        this.container = null;

        window.addEventListener('load', () => this.handleRoute());
        window.addEventListener('popstate', () => this.handleRoute());
    }

    setContainer(container) {
        this.container = container;
    }

    async handleRoute() {
        if (!this.container) return;

        const path = window.location.pathname;
        const pageName = path === '/' ? 'dashboard' : path.substring(1);

        try {
            const pageContent = await this.pageBuilder.buildPageFromJson(pageName);
            if (pageContent) {
                // Eğer pageContent bir HTML elementi ise
                if (pageContent instanceof HTMLElement) {
                    this.container.innerHTML = '';
                    this.container.appendChild(pageContent);
                } else {
                    // String ise doğrudan innerHTML'e ata
                    this.container.innerHTML = pageContent;
                }
            } else {
                this.container.innerHTML = this.notFound || '<div>Sayfa bulunamadı</div>';
            }
        } catch (error) {
            console.error('Sayfa yükleme hatası:', error);
            this.container.innerHTML = this.notFound || '<div>Sayfa bulunamadı</div>';
        }
    }
}